<form [formGroup]="form">
  @for (item of model.items; track item.name) {
    <div class="row g-3">
      <div class="col-auto">
        <div class="form-check">
          <input
            class="form-check-input"
            [ngClass]="{ 'is-invalid': isErrorVisible(item.name) }"
            type="checkbox"
            [attr.id]="item.name"
            [formControlName]="item.name"
            [attr.data-test]="'form-input-' + item.name"
            [attr.aria-describedby]="'form-input-desc--' + item.name"
            [required]="item.required"
            [attr.aria-invalid]="!form.valid && !form.pristine"
          />
        </div>
      </div>
      <div class="col">
        <label
          class="text-secondary fw-semibold mb-2 d-block"
          [for]="item.name"
          [attr.id]="item.name + '-checkbox'"
          [attr.data-test]="'form-label-' + item.name"
          >{{ item.titleKey | translate }}</label
        >
        <p
          #collapsible
          class="mb-0"
          [id]="'description-' + item.name"
          [ngClass]="item.open || item.showMore === false ? '' : 'clamp-2'"
          [innerHTML]="item.descriptionKey | translate: item.descriptionValues | safeHtml"
        ></p>

        @if (isLineClampNeeded(item) || item.showMore === true) {
          <p class="mb-0">
            <button
              class="btn btn-clean text-secondary"
              style="text-transform: none; letter-spacing: 0"
              mweClickPreventDefault
              (click)="toggleReadMore(item.name)"
              aria-hidden="true"
            >
              {{ (item.open ? model.showLessKey : model.showMoreKey) | translate }}
            </button>
          </p>
        }

        @if (isErrorVisible(item.name)) {
          <span [id]="'form-input-desc--' + item.name" class="invalid-feedback d-block">{{ item.errorKey | translate }}</span>
        }

        @if (item.hintKey && !form.controls[item.name].value) {
          <span class="hint-error d-block">{{ item.hintKey | translate }}</span>
        }
      </div>
    </div>
    @if (!$last) {
      <hr />
    }
  }
</form>
